import React from 'react';
import styles from './IntegrationPlaceholder.module.scss';

type IntegrationPlaceholderProps = {
  title: string;
  description: string;
};

const IntegrationPlaceholder = ({
  title,
  description,
}: IntegrationPlaceholderProps) => (
  <section className={styles.container}>
    <span className={styles.future}>Скоро</span>
    <h2>{title}</h2>
    <p>{description}</p>
  </section>
);

export default IntegrationPlaceholder;
